import {
  FormControlLabel,
  Switch as MuiSwitch,
  SwitchProps,
  Tooltip,
  Typography,
  styled,
} from '@mui/material';
import { FC } from 'react';

const SwitchLabel = styled(FormControlLabel)({
  margin: 0,
});

type Props = Pick<SwitchProps, 'color' | 'edge'> & {
  label?: string;
  checked?: boolean;
  name?: string;
  onChange?: (checked: boolean) => void;
  tooltip?: string;
  disabled?: boolean;
};

const Switch: FC<Props> = ({
  label,
  checked,
  name,
  onChange,
  color = 'secondary',
  tooltip,
  disabled,
  edge,
}) => {
  const labelVariant = checked ? 'h6' : 'body2';
  const labelColor = checked ? 'grey.900' : 'grey.500';

  const switchLabel = (
    <SwitchLabel
      disabled={disabled}
      control={
        <MuiSwitch
          size="medium"
          color={color}
          checked={!!checked}
          name={name}
          onChange={(_, checked) => {
            onChange?.(checked);
          }}
          disabled={disabled}
          edge={edge}
          sx={disabled ? { pointerEvents: 'none' } : undefined}
        />
      }
      label={
        <Typography variant={labelVariant} color={labelColor}>
          {label}
        </Typography>
      }
      labelPlacement="start"
    />
  );

  if (!tooltip) {
    return switchLabel;
  }

  return (
    <Tooltip title={tooltip}>
      <span style={{ display: 'inline-flex' }}>{switchLabel}</span>
    </Tooltip>
  );
};

export default Switch;
